import React from "react";
import { NavLink, Link } from "react-router-dom";
import { useIsAuthenticated, useMsal, AuthenticatedTemplate } from "@azure/msal-react";
import WelcomeName from "./WelcomeName";
import { SignOutButton } from "./SignOutButton";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const NavBar = () => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <nav className="navbar navbar-expand-md navbar-light bg-white fixed-top shadow-sm">
            <div className="container-fluid">
                {/* Logo */}
                <Link className="navbar-brand d-flex align-items-center" to="/">
                    <img 
                        src="/LogoUnep.png"
                        alt="Logo"
                        style={{ height: '50px', marginBottom: '5px', marginLeft: '3em' }}
                    />
                </Link>

                {/* Mobile toggle */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarContent"
                    aria-controls="navbarContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Navigation styles */}
                <style>
                    {`
                        .mui-nav-button {
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            background-color: transparent;
                            border: none;
                            margin: 0 5px;
                            border-radius: 4px;
                            padding: 8px;
                            cursor: pointer;
                            color: #000;
                            font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                            font-weight: 500;
                            font-size: 0.875rem;
                            text-decoration: none;
                            transition: background-color 250ms ease-in-out;
                        }

                        .mui-nav-button:hover {
                            background-color: #f0f0f0;
                        }

                        .mui-nav-button.active-link {
                            background-color: #009EDB;
                            color: white;
                        }
                    `}
                </style>

                {/* Navigation links */}
                <div className="collapse navbar-collapse" id="navbarContent">
                    <ul className="navbar-nav mx-auto mb-2 mb-md-0 text-center">
                        {[
                            { to: "/", label: "Home" },
                            { to: "/gloria-mrio", label: "GLORIA MRIO" },
                            { to: "/Metadata", label: "Metadata" },
                            { to: "/Guidelines", label: "Guidelines" },
                            /*{ to: "/contact-us", label: "Contact Us" },*/
                            { to: "/calculator", label: "Footprint Calculator" }
                        ].map(({ to, label }) => (
                            <li className="nav-item" key={to}>
                                <NavLink
                                    to={to}
                                    className={({ isActive }) =>
                                        `mui-nav-button ${isActive ? 'active-link' : ''}`
                                    }
                                >
                                    {label}
                                </NavLink>
                            </li>
                        ))}

                        <li className="nav-item">
                            <WelcomeName />
                        </li>

                        <AuthenticatedTemplate>
                            <li className="nav-item">
                                <SignOutButton />
                            </li>
                        </AuthenticatedTemplate>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default NavBar;
